export const colors = {
    neutral: {
        80050: '#1F1F1F80',
        800: '#1F1F1F',
        700: '#666666',
        600: '#999999',
        500: '#CCCCCC',
        400: '#D9D9D9',
        300: '#E6E6E6',
        200: '#F2F2F2',
        100: '#FAFAFA',
        0: '#FFFFFF',
    },
    primary: {
        orange: {
            700: '#993100',
            600: '#B23A00',
            500: '#D64000',
            400: '#EE5005',
            300: '#FFBA99',
            200: '#FFEEE5',
            100: '#FFF0E5',
        },
    },
    secondary: {
        green: {
            600: '#224C1A',
            500: '#387C2B',
            400: '#77CA68',
            300: '#BBE5B3',
            200: '#EEF8EC',
        },
        blue: {
            600: '#043362',
            500: '#1573D3',
            400: '#3A98F8',
            300: '#9DCBFB',
            200: '#E6F2FE',
            100: '#F9FAFC',
        },
        red: {
            600: '#920707',
            500: '#DC0A0A',
            400: '#F63C3C',
            300: '#FB9D9D',
            200: '#FEE7E7',
        },
        yellow: {
            600: '#895900',
            500: '#FEA601',
            400: '#FEB734',
            300: '#FFDB99',
            200: '#FFF6E6',
        },
        purple: {
            600: '#490679',
            500: '#750AC2',
            400: '#A83DF5',
            300: '#D49EFA',
            200: '#F4E7FE',
        },
        pink: {
            600: '#800074',
            500: '#CF17BF',
            400: '#F658E9',
            300: '#FC9CF4',
            200: '#FDE7FB',
        },
        gray: {
            400: '#737373',
        },
    },
    tertiary: {
        product: {
            green: {
                500: '#123015',
                400: '#294437',
                300: '#596E63',
            },
            beige: {
                500: '#B17644',
                400: '#DD9455',
                300: '#E3A874',
            },
        },
    },
};
